import * as actionTypes from '../actionTypes';

export function setNotificationLink(notificationLinkName) {
	return {
		type: actionTypes.SET_NOTIFICATION_LINK,
		payload: notificationLinkName
	};
}
